import React from "react";
import { Webhook } from "../../../../../../models/Entities";
import clsx from "clsx";
import { ChevronRight } from "lucide-react";
import { Tooltip, SkeletonLoader } from "@merge-api/merge-javascript-shared";

interface WebhookRowProps {
  webhook?: Webhook;
  isLoading: boolean;
  isLastWebhook: boolean;
  onClick?: () => void;
}

const WebhookRow: React.FC<WebhookRowProps> = ({ webhook, isLoading, isLastWebhook, onClick }) => {
  return (
    <div
      className={clsx(
        "flex flex-row items-center cursor-pointer min-w-0 hover:bg-gray-0 px-6 py-4",
        isLastWebhook ? null : "border-b border-gray-10",
        isLoading ? null : "justify-between",
      )}
      onClick={onClick}
    >
      {isLoading ? (
        <SkeletonLoader width={221} height={20} borderRadius={4} />
      ) : (
        // Webhook target URL is customer-supplied; masked at the cell for PostHog and Frigade.
        // The portal-mounted Tooltip body is PostHog-only (maskTextSelector), not data-fr-ignore
        // reachable, so the full URL is in the Frigade snapshot while it's open. See the portal
        // caveat in .claude/rules/frigade.md.
        <div
          className="ph-no-capture flex flex-row items-center justify-center min-w-0"
          data-fr-ignore
        >
          {webhook && (
            <Tooltip title={webhook?.target} className="min-w-0 truncate">
              <>{webhook.target}</>
            </Tooltip>
          )}
        </div>
      )}
      {!isLoading && <ChevronRight className="text-gray-40" size={16} />}
    </div>
  );
};

export default WebhookRow;
